<template>
  <a-table
    :columns="columns"
    :data-source="list"
    :scroll="{ x: 0, y }"
    :pagination="false"
    :loading="loading"
    :destroyOnClose="true"
    :forceRender="true"
    :rowClassName="rowClassName"
  >
    <template slot="content" slot-scope="text,record">
      {{text|numberFixed(record.unit ==='MJ' || record.unit === 'Kcal'? 0 : 2)}}
    </template>
    <template slot="productContent" slot-scope="text,record">
      {{text|numberFixed(record.unit ==='MJ' || record.unit === 'Kcal'? 0 : 2)}}
    </template>
    <template slot="difference" slot-scope="text, record">
      <span
        :class="{
          red:
            record.content && record.content !== 0 ? 
            Number((record.content || 0) - (record.productContent || 0)) > 0 
            : false,
          green:
            record.content && record.content !== 0 ? 
            Number((record.content || 0) - (record.productContent || 0)) < 0
            : false
        }"
      >
        {{getNum(record)}}
      </span>
    </template>
  </a-table>
</template>

<script>
import { nhfMixins } from '../../untils'
// import { exportExcel } from "@/Utils/excel/Export2Excel";
export default {
  props:['hidden','tabKey','y','diff','loading'],
  mixins:[nhfMixins],
  data(){
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      cacheData:[],
      columns:[
        {
          dataIndex:'nutritionName',
          title:'指标名称',
          width:120,
        },
        {
          dataIndex:'nutritionCode',
          title:'指标代码',
          width:100,
        },
        {
          dataIndex:'unit',
          title:'单位',
          width:100,
        },

        {
          dataIndex:'content',
          title:'配方',
          width:100,
          scopedSlots: {customRender: 'content'},
        },
        {
          dataIndex:'productContent',
          title:'产品',
          width:100,
          scopedSlots: {customRender: 'productContent'},
        },
        {
          dataIndex:'diff',
          title:'差异',
          width:100,
          scopedSlots: {customRender: 'difference'},
          sortOrder:'descend',
          // sorter: (a, b) => {
          //   let an = a.diff ? Math.abs(Number(a.diff)) : 0
          //   let bn = b.diff ? Math.abs(Number(b.diff)) : 0
          //   return an - bn
          // },
          align:'center'
        },
      ],
      list:[],
      batStatus:false,
      keyword:'',
      equationId:null,
      types:[],
      listLoading:false,
      calculateLoading:false,
      nutritionId:null,
      calculateResult:[],
      isContain:true,
      equation:{
        records:[]
      },
    }
  },
  watch:{
    hidden(visible){
      if(visible) this.getList()
    },
    // tabKey(val){
    //   if(val === '2') this.getList()
    // }
    diff(){
      this.filterList()
    }
  },
  mounted(){
    this.getList()
  },
  computed:{
    eidtorText(){
      return this.batStatus ? '取消编辑' : '批量编辑'
    }
  },
  methods:{
    toggleContain(isContain,list = false){
      this.$nextTick(()=>{
        let arrs = list || this.cacheData
        let arr = JSON.parse(JSON.stringify(arrs))
        this.list.records = isContain ? arr : arr.filter(i => i.isContain === "1")
      })
    },

    selectItem(val){
      if(val === undefined) {
        this.getList()
      }
    },

    typeChange(val){
      this.types = val
      this.getList({typeId:[...val].pop()})
    },

    async getList(arg= {}){
      this.$nextTick( async () => {
        const params = {
          formulaId:this.formulaId,
        }
        if(this.types.length) params.typeId=[...this.types].pop()
        this.listLoading = true
        const res = await this.getNutritionContrast({
          ...params,
          ...arg,
          size:1000
        }).finally(() => {
          this.$emit('checkLoadling')
        })
        if(res && res.data && res.msg !== '暂无承载数据'){
          res.data && res.data.map(el => {
            el.difference = Math.abs(this.getNum(el,'row'))
            return el
          })
          // this.list = res.data || []
        }
        this.listLoading = false
        // 差异值按照绝对值从大到小排序
        this.cacheData = JSON.parse(JSON.stringify(res ? res.data || [] : []))
        this.filterList()
      })
    },

    listChange(page){
      this.getList({...this.tablePageChange(page),...this.filterData})
    },

    filterList(){
      if(this.diff){
        this.list = this.cacheData.filter(el => !!el.difference)
      }else{
        this.list = JSON.parse(JSON.stringify(this.cacheData))
      }
    },

    ok(){
      this.$emit('ok')
      this.resetRaw()
    },

    cancel(){
      this.$emit('cancel')
      this.resetRaw()
    },

    resetRaw(){
      this.keyword = ''
      this.types = []
      this.list.records = [...this.cacheData]
      this.cleanSelect()
    },
    getNum(record,type){
      let {content,productContent,unit} = record || {}
      let num
      let len = unit === 'Kcal' || unit === 'MJ' ? 0 : 2
      if(content || productContent || content === 0 || productContent === 0){
        num = Number((content || 0) - (productContent || 0)).toFixed(len)
      }else{
        if(type === 'row') num = 0
      }
      return num
    },
    rowClassName(record){
      let {isExtraProRaw,isRawDelete} = record || {}
      return isExtraProRaw == '1' || isRawDelete == '1' ? 'selectGary' : ''
    },
    downloadExcel() {
      let tHeader = this.columns.map((item) => {
        if(item.dataIndex != 'x') return item.title
      });
      let filterVal = this.columns.map((item) => item.dataIndex);
      let tTitle = `${this.detail.formulaName}-${new Date().getTime()}`;
      const list = this.list;
      const data = this.formatJson(filterVal, list);
      // exportExcel(tHeader, data, tTitle);
      return {tHeader, data, tTitle}
    },
    formatJson(filterVal, jsonData) {
      let arr = ['content','productContent','diff']
      return jsonData.map((v) => filterVal.map((j) => {
        if(arr.includes(j)){
          if(j === 'diff'){
            return v[j] || v[j] === 0 ? this.getNum(v) : ''
          }else{
            let len = v.unit === 'Kcal' || v.unit === 'MJ' ? 0 : 2 
            return v[j] || v[j] === 0 ? Number(v[j]).toFixed(len) : ''
          }
        }else{
          return v[j]
        }
      }));
    },
  }
}
</script>
<style lang="scss" scoped>
.red {
  color: red;
}
.green {
  color: green;
}

</style>
<style lang="scss">
.grayBg{
  td{
    background: gray;
  }
}
</style>
